export default{
    cadastra:{
        method:'post',
        url:'rescisaocontrato/cadastro'
    },
    rescisaocadastra:{
        method:'post',
        url:'rescisao/contrato/tabela/cadastro'
    },
    rescisaoupdate:{
        method:'post',
        url:'rescisao/contrato/tabela/update'
    },
    delete:{
        method:'delete',
        url:'rescisaocontrato/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'rescisaocontrato/lista'
    },
    editar:{
        method:'get',
        url:'rescisaocontrato/editar{/id}'
    },
    update:{
        method:'post',
        url:'rescisaocontrato/update'
    },
    evento:{
        method:'get',
        url:'rescisaocontrato/evento/2200{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
}